<template>
  <div id="app">
    <router-view :key="key"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  background-color: #fff;
}
</style>
